<div class="login-lang" *ngIf="showLanguageSelection">
    <button [matMenuTriggerFor]="langSwitcher" mat-icon-button>
        <mat-icon class="m-0">language</mat-icon>
    </button>
    <mat-menu #langSwitcher="matMenu" class="lang-switcher">
        <button mat-menu-item (click)="useLanguage('he')" [disabled]="translate.currentLang=='he'">
            עברית
        </button>
        <button mat-menu-item (click)="useLanguage('en')" [disabled]="translate.currentLang=='en'">
            English
        </button>
    </mat-menu>
</div>

<div #mainContainer class="main-container" [dir]="translate.currentLang=='he'?'rtl':'ltr'">
    <!-- ============================================================== -->
    <!-- Topbar - style you can find in header.scss -->
    <!-- ============================================================== -->
    <mat-toolbar *ngIf="!fullScreen" color="primary" class="topbar telative">
        <!-- ============================================================== -->
        <!-- sidebar toggle -->
        <!-- ============================================================== -->

        <button mat-icon-button value="sidebarclosed" (click)="snav.toggle()">
            <mat-icon>menu</mat-icon>
        </button>
        <!-- ============================================================== -->
        <!-- Logo - style you can find in header.scss -->
        <!-- ============================================================== -->
        <div class="navbar-header">
            <!-- <a class="navbar-brand" href="index.html"> -->
            <div class="navbar-brand">
                <!-- Logo icon --><span>
                    <!-- You can put here icon as well // <i class="wi wi-sunset"></i> //-->
                    <!-- Dark Logo icon -->
                    <!-- <img src="assets/images/logo-icon.png" alt="homepage" class="dark-logo"> -->
                    <!-- Light Logo icon -->
                    <!-- <img src="assets/images/logo-light-icon.png" alt="homepage" class="light-logo"> -->

                </span>
                <!--End Logo icon -->
                <!-- Logo text -->
                <span fxShow="false" fxShow.gt-xs *ngIf="appState?.user">
                    <!-- dark Logo text -->
                    <!-- <img src="assets/images/logo-text.png" alt="homepage" class="dark-logo"> -->
                    <!-- Light Logo text -->
                    <!-- <img src="assets/images/logo-light-text.png" class="light-logo" alt="homepage"> -->
                   
                    <!-- {{'MAIN-APP.ADMIN' | translate}}  -->
                    {{appState?.user?.name}}
                </span>
            </div>
            <!-- </a> -->
        </div>

        <!-- <a *ngIf="showAddBtn" mat-stroked-button [routerLink]="['./', 'new']">{{ 'ADD' | translate }}</a> -->

        <span fxFlex></span>
        <!-- ============================================================== -->
        <!-- app header component - style you can find in header.scss / header.component.ts-->
        <!-- ============================================================== -->
        <!-- <app-header></app-header> -->
        <button mat-raised-button (click)="stopCampaign()">{{'MAIN-APP.STOP_CAMPAIGN' | translate}}</button>
        <button mat-raised-button (click)="logout()">{{'MAIN-APP.DISCONNECT' | translate}}</button>
    </mat-toolbar>
    <!-- ============================================================== -->
    <!-- End Topbar - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
        <mat-sidenav #snav id="snav" class="dark-sidebar pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0" [opened]="appState.sideNavOpen" [disableClose]="mobileQuery.matches" (openedChange)="snavOpenedChange($event)">

            <app-sidebar [inputSideNav]="snav"></app-sidebar>


        </mat-sidenav>
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
        <mat-sidenav-content class="page-wrapper">

            <div class="page-content">

                <router-outlet>
                    <app-spinner></app-spinner>
                </router-outlet>

            </div>

        </mat-sidenav-content>
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
    </mat-sidenav-container>
</div>